var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightswitchOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 23,
    r: 9,
    fill: "#F0F0F0",
    fillOpacity: 0.46
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5996 8C27.8601 8 29.0996 8.96055 29.0996 10.4004V14.4092C32.0277 16.1584 34 19.3595 34 23C34 28.5 29.5 33 24 33C18.5 33 14 28.5 14 23C14 19.3186 16.0174 16.0873 19 14.3516V10.4004C19 8.96055 20.2395 8 21.5 8H26.5996ZM24 15C19.6 15 16 18.6 16 23C16 27.4 19.6 31 24 31C28.4 31 32 27.4 32 23C32 18.6 28.4 15 24 15ZM21.5 10C21.3482 10 21.2134 10.0577 21.123 10.1396C21.0377 10.2172 21 10.3066 21 10.4004V13.4629C21.948 13.1625 22.9559 13 24 13C25.0809 13 26.1225 13.176 27.0996 13.4971V10.4004C27.0996 10.3066 27.0629 10.2172 26.9775 10.1396C26.8872 10.0575 26.7516 10 26.5996 10H21.5Z",
    fill: "#C9C9D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 36.2998V38.9998",
    stroke: "#F0F0F0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6002 32.4004L12.7002 34.3004",
    stroke: "#F0F0F0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7 23H8",
    stroke: "#F0F0F0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6002 13.6002L12.7002 11.7002",
    stroke: "#F0F0F0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4004 13.6002L35.3004 11.7002",
    stroke: "#F0F0F0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2998 23H39.9998",
    stroke: "#F0F0F0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4004 32.4004L35.3004 34.3004",
    stroke: "#F0F0F0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightswitchOn);
export default __webpack_public_path__ + "static/media/lightswitch_on.3257e274d54b02772a09cd1bdf64c4c7.svg";
export { ForwardRef as ReactComponent };